import Vue from 'vue';

export default {
    loadAllEventsSuccess(state, payload) {
        Vue.set(state.events, 'data', payload);
        Vue.set(state.events, 'dataIsLoading', false);
    },
    loadAllEventsError(state) {
        Vue.set(state.events, 'dataIsLoading', false);
        Vue.set(state.events, 'hasError', true);
    },

};
